export default 'https://tme.understood.org/assets/collectible.7ea9e292.glb'